import type { RecipeDocType } from '../validators';
import type { Assert, AssertEqual } from './type-assertions';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';
import { defineRxdbCollectionModel } from './migration';

// ============================================================================
// RxDB collection schema for recipes.
//
// Document shape mirrors the D1 `recipes` row. `body` is opaque JSON.
// ============================================================================

export const RECIPES_COLLECTION = 'recipes' as const;
export const RECIPES_SCHEMA_VERSION = 0;

export const recipesSchemaLiteral = {
  title: 'recipes schema',
  version: RECIPES_SCHEMA_VERSION,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    userId: { type: 'string', maxLength: 100 },
    body: { type: 'object' },
    createdAt: { type: 'string', maxLength: 30 },
    updatedAt: { type: 'string', maxLength: 30 },
    deletedAt: { type: ['string', 'null'] },
  },
  required: ['id', 'userId', 'body', 'createdAt', 'updatedAt', 'deletedAt'],
  indexes: [['userId', 'updatedAt']],
} as const;

export interface RecipesCheckpoint {
  updatedAt: string;
  id: string;
}

type _RecipeSchemaDocType = Omit<ExtractDocumentTypeFromTypedRxJsonSchema<typeof recipesSchemaLiteral>, 'body'> & {
  body: RecipeDocType['body'];
};
type _RecipeDocTypeInSync = Assert<AssertEqual<_RecipeSchemaDocType, RecipeDocType>>;

export const recipeSchema: RxJsonSchema<RecipeDocType> = recipesSchemaLiteral;
export const recipesModel = defineRxdbCollectionModel<typeof RECIPES_COLLECTION, RecipeDocType>({
  collection: RECIPES_COLLECTION,
  schema: recipeSchema,
});
